import React, { useCallback } from "react";
import { CustomButton } from "../../../../../../components/Button/Button";
import { Grid } from "@mui/material";

const WatchlistButton = ({
  inWatchlist,
  removeWatchListMutate,
  mutate,
  cardId,
  isMobile,
}) => {
  const handleRemoveWatchList = useCallback(() => {
    removeWatchListMutate(cardId);
  }, [removeWatchListMutate, cardId]);
  const handleAddWatchList = useCallback(() => {
    mutate(cardId);
  }, [mutate, cardId]);

  return (
    <Grid item className="sidebar-worklog">
      <div className={`sidebar-worklog-detail ${isMobile ? "uppercase" : ""}`}>
        {isMobile ? "View " : ""}Details
      </div>
      <div className="sidebar-Addworklog-btn">
        <CustomButton
          onClick={inWatchlist ? handleRemoveWatchList : handleAddWatchList}
          className="reset-btn"
        >
          {inWatchlist ? "Remove from Watchlist" : "Add to Watchlist"}
        </CustomButton>
      </div>
    </Grid>
  );
};

export default React.memo(WatchlistButton);
